import { render, staticRenderFns } from "./ChatComment.vue?vue&type=template&id=aad247e0&scoped=true&lang=pug&"
import script from "./ChatComment.vue?vue&type=script&lang=js&"
export * from "./ChatComment.vue?vue&type=script&lang=js&"
import style0 from "./ChatComment.vue?vue&type=style&index=0&id=aad247e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad247e0",
  null
  
)

export default component.exports